enum ProjectContainerStatus {
  Active = 1,
  Passive = 2
}

export default ProjectContainerStatus;
